import { ISortableFilter }          from '../common/sortable-filter';
import { IBaseService }             from './service.interface';
import { lastValueFrom, Observable, of }               from 'rxjs';
import { CommonService }            from './common.service';
import { HttpClient }               from '@angular/common/http';
import { Globals }                  from '../common/globals';
import { CompanyViewModel }         from '../setting/company/company-view.model';
import { catchError, share }                    from '../../../node_modules/rxjs/operators';
import { Injectable } from '@angular/core';
import { HcLocalStorage } from '../common/local-storage';

@Injectable()
export class CompanyService implements IBaseService<any> {

    private _commonService: CommonService;

    private companies: Array<CompanyViewModel> = null;

    private _selectedCompanyID = -1;

    public set setCompanyID(companyID: number) {
        this._selectedCompanyID = companyID;
    }

    public get getCompanyID(): number {
        return this._selectedCompanyID || -1;
    }

    constructor(private http: HttpClient, 
                private globals: Globals,
                private hcLocalStorage: HcLocalStorage
        ) {
        this._commonService = new CommonService(http, globals, 'company');
        this._commonService.getCustomHeaders = () => {
            return {
                'X-Airme-CompanyId': this.getCompanyID.toString()
            };
        };
    }

    public async loadCompanies() {
        let cps = lastValueFrom(await this.getItems()) as any;
        this.companies = cps as Array<CompanyViewModel>;
    }

    public async hasMultipleCompanies(): Promise<boolean> {
        if (this.companies == null) {
            await this.loadCompanies();
        }
        return this.companies.length > 1;
    }

    public async getPreloadedCompanies(): Promise<Array<CompanyViewModel>> {
        if (this.companies == null) {
            await this.loadCompanies();
        }
        return this.companies;
    }


    public getItems(): Observable<any> {
        return this._commonService.get('listAll');
    }

    public async setCountryIsoCode() {
        let res = await lastValueFrom(this._commonService.get('listAll').pipe(catchError((e, c) => { console.error(e); return of(false); })));

        if (res && res[0].hasOwnProperty('currencyIsoCode')) {
            this.hcLocalStorage.companyCurrencyISOCode = res[0].currencyIsoCode;
        } else {
            this.hcLocalStorage.companyCurrencyISOCode = '';
        }
        if (res && res[0].hasOwnProperty('countryIsoCode')) {
            this.hcLocalStorage.companyCountryISOCode = res[0].countryIsoCode;
        } else {
            this.hcLocalStorage.companyCountryISOCode = '';
        }
    }

    public getActive(): Observable<CompanyViewModel> {
        /*
        if (this.companies == null) {
            await this.loadCompanies();
        }
        return Observable.create(this.companies.find(c => c.companyId === this._selectedCompanyID));*/
        return this._commonService.get('getActive').pipe(share()) as Observable<CompanyViewModel>;
    }

    public searchItems(filter: ISortableFilter): Observable<any> {
        return this._commonService.post('getCompanies', filter);
    }

    public deleteItem(id: any): Observable<any> {

        return this._commonService.delete(id);
    }
    public async insertCompany(item: any): Promise<any> {
        this.companies = null;
        let res = await this._commonService.post('', item).toPromise();
        await this.loadCompanies();
        return res;
    }

    public async updateCompany(id: any, item: any): Promise<any> {
        this.companies = null;
        let res = await this._commonService.updateItem(id + '', item).toPromise();
        await this.loadCompanies();
        return res;
    }
    public getDetail(id: string): Observable<any> {
        return this._commonService.get(id);
    }

    public updateItem(id: string, item: any): Observable<any> {
        // Use update company instead
        return Observable.create(null);
    }
    public insertItem(item: any): Observable<any> {
        // Use insert company instead
        return Observable.create(null);
    }
}
